<div class="root-div">
  <button
    #columnButton
    type="button"
    pButton
    pRipple
    (click)="toggleMultiselect($event)"
    pTooltip="Show / Hide Columns"
    tooltipPosition="bottom"
    class="p-button-text p-button-plain p-button-lg tool-bar-pbutton icon-top-space-toolbar icon-right-space-toolbar icon-left-space-toolbar">
    <span class="material-symbols-outlined"> view_column_2 </span>
  </button>
  <p-multiselect
    #multiselect
    [options]="columns"
    [(ngModel)]="selectedColumns"
    optionLabel="header"
    selectedItemsLabel="{0} columns selected"
    [style]="{ position: 'absolute', visibility: 'hidden', height: '0', width: '0' }"
    placeholder="Choose Columns"
    display="chip"
    (onChange)="onSelectionChange()"
    appendTo="body"
    [dropdownIcon]="''"
    [panelStyle]="{ 'min-width': '250px', 'margin-top': '50px' }"
    panelStyleClass="column-show-hide-panel">
  </p-multiselect>
</div>
